'use client'
import { encryptPassword, getDeviceType } from '@/src/lib/utils';
import { useUIDQuery } from '@/src/queries/guest/uid-query';
import { useToken } from '@/src/store/token-store';
import axios from 'axios';
import React, { useState, useEffect } from 'react';
import HomeAdsense from '../home/home-adsense';
import { useTags } from '@/src/store/tag-store';
import { Box } from '@chakra-ui/react';

interface AdBannerProps {
    url: string;
    mobUrl: string;
    web: string;
    mob: string;
    trackId: string
}

export const CustomAdBanner = () => {
    const { selectedTagId } = useTags()
    const [isMobile, setIsMobile] = useState(typeof window !== 'undefined' && window.innerWidth <= 768);
    const uidQuery = useUIDQuery()
    const [adData, setAdData] = useState<AdBannerProps>({ url: '', web: '', mob: '', trackId: '', mobUrl: '' });
    const { accessToken } = useToken()

    useEffect(() => {
        if (typeof window !== 'undefined') {
            const handleResize = () => {
                setIsMobile(window.innerWidth <= 768);
            };
            window.addEventListener('resize', handleResize);
            return () => {
                window.removeEventListener('resize', handleResize);
            };
        }

    }, []);
    useEffect(() => {
        if (uidQuery.isFetched)
            getAd(uidQuery.data)
    }, [uidQuery.isFetched])

    const handleClick = () => {
        if (typeof window === 'undefined') {
            return null; // Return null if the function is called on the server
        }
        handleTrack(adData.trackId)
        window.open(isMobile ? adData.mobUrl : adData.url, '_blank');
    };

    const getAd = async (cookieId: string) => {
        let port = process.env.NEXT_PUBLIC_ENVIRONMENT === 'dev' ? '9058' : '9059'
        if (accessToken) {
            const initiateResponse = await axios.get(`https://ad.lykstage.com:${port}/ban/ad`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                    'x-ban-pg': window.location.pathname,
                    'x-ban-cki': cookieId,
                    'x-ban-platform': getDeviceType()

                }
            });
            setAdData(initiateResponse.data.response.campaign);
        } else {
            const initiateResponse = await axios.get(`https://ad.lykstage.com:${port}/ban/guestAd`, {
                headers: {
                    'x-ban-pg': window.location.pathname,
                    'x-ban-cki': cookieId,
                    'x-ban-platform': getDeviceType()
                }
            });
            setAdData(initiateResponse.data.response.campaign);
        }
    }
    const handleTrack = (trackId: string) => {
        if (trackId) {
            axios.get(`${'https://ad.lykstage.com:9058'}/ban/trck/${trackId}`);
        }
    }
    // if (selectedTagId) return null
    if (!adData?.trackId) {
        return null;
        // return <HomeAdsense />
    }
    return (
        <Box w="100%" gridColumn="1 / -1">
            <div style={{ cursor: 'pointer' }}>
                <img
                    onClick={handleClick}
                    src={isMobile ? adData.mob : adData.web}
                    alt="banner"
                    style={{ width: isMobile ? '100%' : 'auto', maxWidth: '100%', margin: "20px auto 0px" }}
                />
            </div>
        </Box>
    );
};